var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "heart",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.49 55.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .1px;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.75,
    y1: 27.85,
    x2: 55.75,
    y2: 27.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#721016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#84161a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#8d191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#90191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9a1b1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#aa1e22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#c12227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8d191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#931b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8e191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8d191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7244a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 46.74,
    y1: 14.74,
    x2: 12.1,
    y2: 19.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2484c6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 18.97,
    y1: 31.67,
    x2: 19.64,
    y2: 52.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#721016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#84161a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#8d191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#90191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9a1b1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#aa1e22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#c12227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8d191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#721016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#781217"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#84161a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#8b181b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8d191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7244a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 21.38,
    y1: 41.1,
    x2: 19.8,
    y2: 17.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#f8dbe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f0aeb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e98798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e3677c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#df4f67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#dc3d58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#da334f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#da304d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#c62a40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ad2230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9b1d25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#901a1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8d191c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 40.56,
    y1: 42.34,
    x2: 37.63,
    y2: 19.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 39.92,
    y1: 35.38,
    x2: 38.22,
    y2: 20.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f05876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#e64664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#da304d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c62a40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ad2230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b1d25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#901a1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d191c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-24D"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.21,31.2s5.9-13.44-11.53-15.95c0,0-10.49-1.56-22.63,4.51S.06,35.1,1.97,42.99c0,0-.81,.09-.92-.49,0,0-1.42-5.09,2.02-10.32,0,0,6.48-11.68,23.59-17.22,0,0,10.94-4.39,21.69-.92,0,0,12.66,3.99,4.86,17.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.6,19.25s.83,.78,.62,1.78l-1.17-1.42s-.6-1.42,.55-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.18,15s-.78,.69-1.39,.69-13.01-5.03-33.64,6.85c0,0,14.74-11.96,33.12-8.32,0,0,1.82-.09,1.91,.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.43,37.62l-1.16,5.09H7.95s.92-3.87,4.97-6.65c0,0,5.38-3.41,6.42-3.93s3.81-2.2,4.22-4.28-2.08-2.31-2.08-2.31c0,0-3.02-.61-4.34,4.05l-5.78,.06s.92-5.14,5.2-7.51,9.07-1.21,9.07-1.21c0,0,6.13,1.16,4.1,6.94,0,0-.46,3.81-6.07,6.42l-6.13,3.29,9.88,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M17.44,37.2l6.06-3.22c5.31-2.43,5.97-6.32,5.97-6.32,1.84-5.37-4.19-6.45-4.19-6.45,0,0-4.54-1.08-8.59,1.13s-4.93,7.01-4.93,7.01l5.19-.03c1.23-4.66,4.67-4.02,4.67-4.02,0,0,2.56,.36,2.31,2.33-.31,2.39-3.14,4.06-4.12,4.55-.99,.49-6.2,3.81-6.2,3.81-.89,.6-1.37,.92-1.97,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.04,21.03h-6.13l-13.06,12.25-1.02,4.97h10.09l-1.06,4.45h6.15l.98-4.45h2.66l1.1-4.68h-2.6l2.89-12.54Zm-8.96,12.77h-4.86c-.81-.17,0-.69,0-.69,0,0,5.55-5.49,5.9-5.9,.35-.4,.52,0,.52,0l-1.56,6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.06,21.3l-12.92,12.2-.51,2.48,16.14-2.25,2.92-12.43h-5.64Zm-2.98,12.5s-4.42,.01-4.86,0-.29-.48-.29-.48c0,0,5.81-5.72,6.18-6.11s.52,0,.52,0l-1.56,6.59Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24D);
export default __webpack_public_path__ + "static/media/24D.796ddf56b6ad291235172a39ea5581c6.svg";
export { ForwardRef as ReactComponent };